import { baseQuery } from './baseQuery';

import type { SelectOption } from '../Select/SelectOption/SelectOption';

export function baseQueryAsync(
  query: string,
  options: SelectOption[] | undefined
): Promise<SelectOption[]> {
  if (!options) {
    return Promise.resolve([]);
  }
  return Promise.resolve(baseQuery(query, options));
}
